export class Logger {
  private devLog = false;
  private prefix = '[BTM logger]';
  constructor(_devLog: boolean) {
    this.devLog = _devLog;
  }

  info(...message: unknown[]) {
    if (this.devLog) {
      console.log(this.prefix, ...message);
    }
  }

  error(...message: unknown[]) {
    if (this.devLog) {
      console.error(this.prefix, ...message);
    }
  }
}
